import Button from "ds/components/Button";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableCellContentProps } from "ds/components/Table/Row/CellContent";

type PoliciesTemplatesTableImportCellProps = TableCellContentProps & {
  onImport: () => void;
  canManagePolicies: boolean;
  isDisabled: boolean;
};

const PoliciesTemplatesTableImportCell = ({
  onImport,
  canManagePolicies,
  isDisabled,
  ...cellProps
}: PoliciesTemplatesTableImportCellProps) => {
  if (!canManagePolicies || isDisabled) {
    return <TableSimpleCell {...cellProps} />;
  }

  return (
    <TableSimpleCell {...cellProps}>
      <Button variant="secondary" size="small" onPress={onImport}>
        Import
      </Button>
    </TableSimpleCell>
  );
};

export default PoliciesTemplatesTableImportCell;
